module.exports = __webpack_public_path__ + "static/img/2.81f0132.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/2.png
// module id = 3+Cr
// module chunks = 35